import { postRequest} from './requset.js'
import StorageUtils from './StorageUtils';
import * as Url from "./Url";

// 生成 UUID（推荐用浏览器原生的 crypto.randomUUID）
function getOrCreateUUID() {
  let uuid = StorageUtils.getStringData('userUuid');
  if (!uuid) {
    if (crypto?.randomUUID) {
      uuid = crypto.randomUUID();
    } else {
      // fallback 简单生成（兼容老浏览器）
      uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }
    StorageUtils.setStringData('userUuid', uuid); // 存到 localStorage
  }
  return uuid;
}

class Tracker {
  constructor() {
    this.baseParams = {
      deviceType: 'PC',
      ip: 'unknown',
      cookieId: getOrCreateUUID(),
      channelType: '',
	    channelId: '',
    };
    this.cacheDuration = 60 * 60 * 1000; // 默认缓存 1 小时
    this.ready = this._initBaseParams();
  }

  // 初始化基础参数
  async _initBaseParams() {
    const ip = await this.getIP();
    this.baseParams.ip = ip;
  }

  // 上报事件（单条）
  async  track(event, content = {}) {
     // 等待 IP 初始化完成
    await this.ready;
     // IP尚未初始化完成时延迟重试
    if (!this.baseParams.ip || this.baseParams.ip === 'unknown') {
      this.baseParams.ip = await this.getIP();
    }
    const eventData = {
      event,
      eventTime: this.getTime(),
      ...this.baseParams,
      content: JSON.stringify(content)
    };

    this._validate(eventData);
    this._send(eventData);
  }

  getTime(){
		var date = new Date(); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
		var Y = date.getFullYear();
		var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
		var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
		var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
		var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
		var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
		return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s;
	}

  // 字段校验
  _validate(data) {
    const REQUIRED_FIELDS = ['event', 'eventTime', 'deviceType'];
    REQUIRED_FIELDS.forEach(field => {
      if (!data[field]) console.error(`[Tracker] 缺失必填字段: ${field}`);
    });
  }

  // 实际上报逻辑
  _send(data) {
      postRequest(Url.HOST+'/usermanage/event/add', data).then(res => {
        console.log('[Tracker] 上报成功:');
      }).catch(err => {
        console.log('[Tracker] 上报失败:');
      });
  }

  // 获取客户端IP（带缓存 + 多源 fallback）
  async getIP() {
    try {
      // 从 localStorage 读取缓存
      const cache = localStorage.getItem('tracker_ip_cache');
      const cacheTime = localStorage.getItem('tracker_ip_time');
      const now = Date.now();

      if (cache && cacheTime && now - cacheTime < this.cacheDuration) {
        return cache;
      }

      // 多个可选接口
      const ipServices = [
        'https://api.ipify.org?format=json',
        'https://ifconfig.me/all.json',
        'https://ipinfo.io/json?token=YOUR_TOKEN' // 需要注册拿免费 token
      ];

      let ip = 'unknown';
      for (let url of ipServices) {
        try {
          const resp = await fetch(url);
          if (!resp.ok) continue;
          const data = await resp.json();
          ip = data.ip || data.ip_addr || (data.ip_address || 'unknown');
          if (ip !== 'unknown') {
            break;
          }
        } catch (err) {
          console.warn('[Tracker] 接口失败:', url, err);
        }
      }

      // 写缓存（不管成功失败）
      localStorage.setItem('tracker_ip_cache', ip);
      localStorage.setItem('tracker_ip_time', now.toString());

      return ip;
    } catch (error) {
      console.error('获取IP失败:', error);
      return 'unknown';
    }
  }
}
// 导出单例
export default new Tracker();